/**
 * Order class
 *
 * @package    DataTable
 * @author     Maxim Lukianenko <mlukianenko@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { FormattedMessage } from 'react-intl';

import { DataTableColumnType } from 'Types';

export default class Order extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        column: DataTableColumnType.isRequired,
        order: PropTypes.string,
        setOrder: PropTypes.func.isRequired,
    };

    /**
     * DefaultProps
     */
    static defaultProps = {
        order: '',
    };

    setOrder = () => {
        const { order, setOrder, column: { key, sortableKey } } = this.props;
        const [, direction = 'asc'] = order.split(' ');
        setOrder(sortableKey || key, direction === 'asc' ? 'desc' : 'asc');
    };

    render() {
        const { order, column: { title, key, sortableKey } } = this.props;
        const [property, direction] = order.split(' ');
        return (
            <TableSortLabel active={property === (sortableKey || key)} direction={direction} onClick={this.setOrder}>
                <FormattedMessage id={title} />
            </TableSortLabel>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTableHead/Order.jsx